import React from "react";
import AppRouter from "./routs/AppRouter";
import "./style.css";

const App = () => {
  return (
    <div>
      <AppRouter />
    </div>
  );
};

export default App;
